/**
 * Logo Detector Service
 * Automatically finds and extracts logos from websites
 */

import { openaiService } from './openaiService';
import { StoredAsset } from './imageHarvester';

export const logoDetector = {
  /**
   * Extract logo from website
   */
  async extractLogo(url: string): Promise<StoredAsset[]> {
    console.log('🎨 Extracting logo from:', url);

    try {
      // Use OpenAI to find logo
      const prompt = `Find the company logo on this website:

URL: ${url}

Look for:
1. Favicon (usually square, small)
2. <img> elements with "logo" in class, id, or alt attribute
3. Header/nav logo images
4. Brand mark in top-left corner

Return JSON:
{
  "logos": [
    {
      "url": "https://example.com/logo.png",
      "type": "main|favicon|alternate",
      "location": "header|footer|favicon",
      "estimatedDimensions": {"width": 200, "height": 60},
      "hasTransparentBackground": true,
      "confidence": 90
    }
  ]
}`;

      const response = await openaiService.generalQuery(
        prompt,
        'You are a logo detection specialist. Return only JSON.'
      );

      const data = JSON.parse(response.replace(/```json\n?/g, '').replace(/```/g, '').trim());
      const logos = data.logos || [];

      console.log(`✅ Found ${logos.length} logo candidates`);

      // Convert to StoredAsset format
      const logoAssets: StoredAsset[] = logos
        .filter((logo: any) => logo.confidence >= 70)
        .map((logo: any) => ({
          url: logo.url,
          originalUrl: logo.url,
          aspectRatio: '1:1', // Logos are typically square
          dimensions: logo.estimatedDimensions || { width: 200, height: 200 },
          alt: 'Company Logo',
          source: 'website' as const,
          uploadedAt: new Date(),
          category: 'logo' as const
        }));

      return logoAssets;
    } catch (error) {
      console.error('Error extracting logo:', error);
      return [];
    }
  },

  /**
   * Get favicon URL
   */
  getFaviconUrl(url: string): string {
    try {
      const urlObj = new URL(url);
      return `${urlObj.origin}/favicon.ico`;
    } catch {
      return '';
    }
  }
};

